import React from "react";
import { Link } from "react-router-dom";
import "./Notfound.scss";

export default function NotFound() {
  return (
    <main className="error-page">
      <div className="error-content">
        <img
          src="/assets/icons/404-error1.png"   // <-- Correct path
          alt="Page Not Found"
          className="error-image"
        />

        <h1 className="error-title">Oops! Page Not Found</h1>
        <p className="error-text">
          The page you’re looking for doesn’t exist or has been removed.
        </p>

        <Link to="/" className="error-button">
          Back To Home
        </Link>
      </div>
    </main>
  );
}
